var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrashcanSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_trashcan-sm_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 63 63",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_trashcan-sm_svg__st1{display:inline;fill:#004aad}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_trashcan-sm_svg__st2",
    d: "M41.1 55.7H45c1.3 0 2.5-1.2 2.7-2.6l3.5-32.2c.2-1.4-.8-2.6-2.1-2.5l-35.3.1c-1.3 0-2.3 1.2-2.1 2.6l3.7 32.2c.2 1.4 1.4 2.5 2.7 2.5h3.3m2.4 0l15-.1M51 12.5c0-.3-.1-.4-.2-.4s-7.7-.4-13.9-.7c0-.3.1-.6.1-.9.1-4-2.3-7.3-5.3-7.5-3.2-.1-5.7 3-5.8 6.9v.9c-7.3-.4-13.4-.7-13.5-.7-.2 0-.4.1-.4.4 0 .3-.1 1.9-.1 2.2 0 .3.1.4.3.4.1 0 16 .8 27.2 1.3 5.6.3 11.3.7 11.4.6.1 0 .2-.1.2-.4-.1-.2 0-1.9 0-2.1zm-16.1-1.4l-7.3-.4V10c.1-2.9 1.7-4.7 3.9-4.6 2.2.1 3.5 2.1 3.4 5 0 .3.1.5 0 .7z"
  })));
}

export default SvgIconTrashcanSm;